import { motion } from "framer-motion";
import React, { FC } from "react";
import SafeImage from "components/SafeImage/SafeImage";
import { TaxonomyType } from "data/types";
import { Link } from "react-router-dom";
import { cardHover } from "utils/motionPresets";

export interface CardCategory5Props {
  className?: string;
  taxonomy: TaxonomyType;
}

const CardCategory5: FC<CardCategory5Props> = ({
  className = "",
  taxonomy,
}) => {
  const { name, href = "/", thumbnail } = taxonomy;
  return (
    <motion.div
      initial="rest"
      whileHover="hover"
      animate="rest"
      variants={cardHover}
      className={className}
    >
      <Link
        to={href}
        className="nc-CardCategory5 flex flex-col bcr-card-modern p-2 sm:p-3 h-full"
        data-nc-id="CardCategory5"
      >
        <div className="flex-shrink-0 relative w-full aspect-[3/2] max-h-[140px] rounded-xl overflow-hidden group">
          <SafeImage
            src={thumbnail}
            alt={name}
            placeholderVariant="default"
            placeholderCompact
            objectFit="cover"
            imgClassName="group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="mt-3 px-1">
          <h2 className="text-sm sm:text-base text-neutral-900 dark:text-neutral-100 font-semibold text-center line-clamp-2 group-hover:text-primary-600 transition-colors">
            {name}
          </h2>
        </div>
      </Link>
    </motion.div>
  );
};

export default CardCategory5;
